import { css } from "@emotion/react"

import { colorsCP } from "@mkt/cp/src/styles/Tokens"
import { above } from "@mkt/cp/src/styles/Breakpoints"
import { container, getDuration } from "@mkt/cp/src/styles/Functions"


export const BannerAlert = (isOpen) => {
  const bannerOpen = css`
    transform: translateY(0);
    transition: transform ${getDuration(2)} ease;

    ${above["m"]} {
      transform: translateY(0);
    }
  `
  return css`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;

    width: 100%;
    padding-top: 24px;
    padding-bottom: 24px;
    color: ${colorsCP["neutral-70"]};
    background-color: ${colorsCP["neutral-20"]};
    border-radius:  16px 16px 0px 0px;

    transform: translateY(100%);
    transition: transform ${getDuration(2)} ease;

    ${above["m"]} {
      padding-top: 32px;
      padding-bottom: 32px;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 0;
    }

    ${isOpen && bannerOpen}
  `
}

export const BannerAlertWrapper = css`
  ${container};
  display: flex;
  align-items: flex-start;
  gap: 16px;
`

export const BannerAlertText = css`
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 600;
  color: ${colorsCP["neutral-70"]};
  width: 100%;

  strong {
    font-weight: 700;
  }
`

export const BannerAlertCloseButton = css`
  width: 24px;
  height: 24px;
  cursor: pointer;
`
